export const GET_LOCALE_INFO = "GET_LOCALE_INFO@language";
export const SET_LOCALE = "SET_LOCALE@language";
export const FETCH_MESSAGES = "FETCH_MESSAGES@language";
export const FETCH_MESSAGES_SUCCESS = "FETCH_MESSAGES_SUCCESS@language";
